import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

const EmailAndCodeAPI = async (
  email: string,
  bottleCode: string,
  name: string,
  token: any
): Promise<number | boolean> => {
  try {
    const entry = bottleCode;
    const config: AxiosRequestConfig = {
      method: "POST",
      // Lokalno (development)
      // url: `http://localhost:6002/api/ultra/politehnika/add-entry-quiz`,
      
      // Produkcija
      url: `https://politehnika-back.firebird.rs/api/ultra/politehnika/add-entry-quiz`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        entry,
        identity: email,
        name,
        recaptchaToken: token,
      },
    };

    const response: AxiosResponse = await axios(config);

    const { data } = response;
    const { code: responseCode } = data;

    return responseCode;
  } catch (error) {
    return false;
  }
};

export default EmailAndCodeAPI;

